export const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const WORD_IN_CURLY_BRACES_REGEX = /{(\w*)}/g;
export const WORD_IN_DOUBLE_CURLY_BRACES_REGEX = /{{(\w*)}}/g;
